module.exports = "<div *ngIf=\"show\" [ngClass]=\"['snackbar-wrap', type]\" @state>\n  <p class=\"snackbar-text\">{{message}}</p>\n</div>"